// Builds a `wa.me` deep link from a company's phone field.
//
// `Company.phone` is normalized and validated by the model. The defensive
// normalization here also supports records saved before that validation was
// introduced.

const BRAZILIAN_PHONE = /^[1-9]\d{9,10}$/;

export function normalizePhoneForWhatsApp(phone: string | null | undefined): string | null {
  if (!phone) return null;

  let digits = phone.replace(/\D/g, '');
  if (digits.startsWith('55') && (digits.length === 12 || digits.length === 13)) {
    digits = digits.slice(2);
  }

  if (digits.startsWith('0') && (digits.length === 13 || digits.length === 14)) {
    digits = digits.slice(3);
  } else if (digits.startsWith('0') && (digits.length === 11 || digits.length === 12)) {
    digits = digits.slice(1);
  }

  return BRAZILIAN_PHONE.test(digits) ? `55${digits}` : null;
}

export function buildWhatsAppUrl(
  phone: string | null | undefined,
  message: string
): string | null {
  const number = normalizePhoneForWhatsApp(phone);
  if (!number) return null;

  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
}
